import { DEFAULT_PAGE_SIZE, normalizePageSize } from './pageSize';

const storagePrefix = 'voltox';

export const getListPageSizeStorageKey = (userId: number | string, pathname: string): string =>
    `${storagePrefix}-${userId}-${pathname.replace(/\//g, '_')}-onPage`;

export const getStoredListPageSize = (userId: number | string | undefined, pathname: string): number => {
    if (!userId) return DEFAULT_PAGE_SIZE;

    try {
        const raw = localStorage.getItem(getListPageSizeStorageKey(userId, pathname));
        if (raw === null) return DEFAULT_PAGE_SIZE;
        return normalizePageSize(JSON.parse(raw));
    } catch {
        return DEFAULT_PAGE_SIZE;
    }
};

export const setStoredListPageSize = (userId: number | string, pathname: string, size: number): void => {
    localStorage.setItem(
        getListPageSizeStorageKey(userId, pathname),
        JSON.stringify(normalizePageSize(size)),
    );
};
